import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { useRef, useLayoutEffect } from "react";
import { useBanner } from "../contexts";
/**
 * We are using CSS transitions and we can not surely get the
 * rendered height at time of prop change. E. g. the header
 * title get line broken so the height is another as previously.
 */

var RESOLVE_TRANSITION_ISSUE = [200, 400, 600, 800, 1000];
var RESOLVE_TRANSITION_ISSUE_TIMEOUT;
/**
 * Persist a height to the banner context.
 */

function useBannerRefToRenderedHeight(name) {
  var ref = useRef(); // eslint-disable-next-line @typescript-eslint/no-unused-vars

  var _useBanner = useBanner(),
      renderedHeights = _useBanner.renderedHeights,
      rest = _objectWithoutProperties(_useBanner, ["renderedHeights"]);

  var updateRenderedHeight = rest.updateRenderedHeight;

  var updateSize = function updateSize() {
    var _ref$current;

    return updateRenderedHeight(name, ((_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.offsetHeight) || 0);
  };

  useLayoutEffect(function () {
    window.addEventListener("resize", updateSize);
    return function () {
      return window.removeEventListener("resize", updateSize);
    };
  }, [name]); // Always persist on updates, too

  useLayoutEffect(function () {
    updateSize();
    clearTimeout(RESOLVE_TRANSITION_ISSUE_TIMEOUT);
    RESOLVE_TRANSITION_ISSUE_TIMEOUT = setTimeout(function () {
      updateSize();

      var _iterator = _createForOfIteratorHelper(RESOLVE_TRANSITION_ISSUE),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var t = _step.value;
          setTimeout(updateSize, t);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }, 100);
  }, Object.values(rest));
  return ref;
}

export { useBannerRefToRenderedHeight };